import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import { firebaseConfig } from '../firebaseConfig';
import './AdminLogin.css';

const AdminForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setError('Please enter your email address');
      return;
    }

    setLoading(true);
    setError('');
    setMessage('');

    try {
      const app = initializeApp(firebaseConfig);
      const auth = getAuth(app);
      
      await sendPasswordResetEmail(auth, email.trim().toLowerCase());
      setSuccess(true);
      setMessage('Password reset email sent! Check your inbox for further instructions.');
    } catch (err) {
      setLoading(false);
      if (err.code === 'auth/user-not-found') {
        setError('No user found with this email address');
      } else if (err.code === 'auth/invalid-email') {
        setError('Please enter a valid email address');
      } else if (err.code === 'auth/too-many-requests') {
        setError('Too many attempts. Please try again later.');
      } else {
        setError(err.message || 'Failed to send reset email');
      }
    }
  };

  if (success) {
    return (
      <div className="admin-login-page">
        <div className="login-box">
          <div className="card card-primary card-outline">
            <div className="card-body login-card-body">
              <div className="text-center mb-4">
                <img src="/fodyfee_logo.png" alt="FodyFee" style={{ width: '80px', height: '80px' }} />
                <h3 className="login-heading">Reset Password</h3>
                <p className="login-subheading">Check your email</p>
              </div>

              <div className="alert alert-success">
                {message}
              </div>

              <div className="row">
                <div className="col-12">
                  <Link to="/admin/login" className="btn btn-primary btn-block">
                    Back to Login
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-login-page">
      <div className="login-box">
        <div className="card card-primary card-outline">
          <div className="card-body login-card-body">
            <div className="text-center mb-4">
              <img src="/fodyfee_logo.png" alt="FodyFee" style={{ width: '80px', height: '80px' }} />
              <h3 className="login-heading">Forgot Password</h3>
              <p className="login-subheading">Enter your email to receive reset instructions</p>
            </div>

            {error && (
              <div className="alert alert-danger">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="input-group mb-3">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-envelope"></span>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-12">
                  <button 
                    type="submit" 
                    className="btn btn-primary btn-block"
                    disabled={loading}
                  >
                    {loading ? 'Sending...' : 'Send Reset Email'}
                  </button>
                </div>
              </div>
            </form>

            <div className="row mt-3">
              <div className="col-12 text-center">
                <Link to="/admin/login" className="forgot-password-link">
                  Back to Login
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminForgotPasswordPage;